
export const initHeader = () => {
  const body = document.body
  const homeHeader = document.querySelector('.home-header')

  let setClassPos = 100
  if (homeHeader) {
    setClassPos = homeHeader.offsetHeight - 100
  }

  window.onscroll = function(ev) {
    if (window.scrollY > setClassPos) {
      body.classList.add('tiny-header')
    } else {
      body.classList.remove('tiny-header')
    }
  }
}
